import { useState, useEffect, useMemo } from 'react';
import { geoMercator, geoPath } from 'd3-geo';
import type { FeatureCollection, MultiPolygon, Polygon } from 'geojson';

type GeoJSONData = FeatureCollection<
	Polygon | MultiPolygon,
	{ id?: string; sigla: string; name: string }
>;

export const useBrazilMap = () => {
	const [brazilGeo, setBrazilGeo] = useState<GeoJSONData | null>(null);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		fetch(
			'https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/brazil-states.geojson'
		)
			.then((res) => {
				if (!res.ok) {
					throw new Error('Falha ao carregar mapa.');
				}
				return res.json();
			})
			.then((data: GeoJSONData) => {
				setBrazilGeo(data);
				setIsLoading(false);
			})
			.catch((err) => {
				setError(err.message || 'Erro ao carregar mapa');
				setIsLoading(false);
			});
	}, []);

	const { projection, pathGenerator } = useMemo(() => {
		const width = 800;
		const height = 800;
		const proj = geoMercator()
			.center([-54, -13])
			.scale(1000)
			.translate([width / 2, height / 2]);

		return {
			projection: proj,
			pathGenerator: geoPath().projection(proj),
		};
	}, []);

	return { brazilGeo, isLoading, error, projection, pathGenerator };
};
